import React from 'react'
import ProductListStore from '../store/ProductList'

const ProductListStoreContext = React.createContext(ProductListStore)

const useProductList = () => React.useContext(ProductListStoreContext)

export default useProductList
